import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { styles } from './FxBadge.styles';

const intl = {
  fx: 'fx'
};

export function FxBadge() {
  return (
    <Box sx={styles.badge}>
      <Typography variant="caption" sx={styles.text}>
        {intl.fx}
      </Typography>
    </Box>
  );
}
